import React from 'react'
import { CheckboxInput } from '@ztechapps/webui.input'
import { useContext } from './CardPanel/Context'

export const IsPartialCheckbox = () => {
  const { isPartial, setIsPartial } = useContext()
  return (
    <CheckboxInput
      value={isPartial}
      onChange={(e) => {
        setIsPartial(e)
      }}
      label={'Is partial or initial payment. You need to fill up the Required fields.'}
    />
  )
}
